import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { FieldSelectorConfig } from "../types";

interface FieldSelectorProps {
  value: string;
  config: FieldSelectorConfig;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export function FieldSelector({ value, config, onChange, disabled }: FieldSelectorProps) {
  return (
    <Select
      value={value}
      onValueChange={onChange}
      disabled={disabled}
    >
      <SelectTrigger className={`shrink-0 ${config.width || "w-24"}`}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {config.allowAll && (
          <SelectItem value="all">All</SelectItem>
        )}
        {config.fields.map((field) => (
          <SelectItem key={field.value} value={field.value}>
            {field.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

